import React from 'react';
import ScrollSnapBox from "../components/ScrollSnapBox";

const CommonBanner = ({ 
  topTitle, // "Why Hydrogen"
  bannerImage, // Banner image source
  bannerImageAlt, // Banner image alt text
  bannerTitle, // "The True Value of Hydrogen"
  welcomeTitle = "Welcome to Our Platform", // Set default value
  welcomeDescription = "Fusce sit amet condimentum purus, ac vehicula erat. Nunc fermentum ac velit nec interdum. Quisque tincidunt vitae metus a imperdiet. Pellentesque lacinia mattis dui, ut molestie erat bibendum et. Vestibulum ut mattis sem, at pulvinar odio. Morbi porta sapien felis, eget semper metus euismod at. Donec vitae condimentum ipsum."
}) => {
  return (
    <>
      <div className='mt-8 md:mt-12 lg:mt-16 mx-6 sm:mx-8 md:mx-10 lg:mx-20'>
        <h1 className="text-theme-blue font-medium mb-2 text-lg sm:text-xl md:text-2xl lg:text-3xl">{topTitle}</h1>
      </div>
      <div className="relative bg-gray-100 w-full mt-8 md:mt-12 lg:mt-16 h-[180px] sm:h-[350px] md:h-[480px] lg:h-[550px] 2xl:h-[650px] overflow-hidden">
        <ScrollSnapBox>
        {({ inView }) => (
          <div className="h-full overflow-hidden">
            <div className="w-full overflow-hidden">
              <div 
                className="w-full transition-all duration-1000 origin-center"
                style={{
                  transform: `scale(${inView ? 1 : 1.2})`,
                  opacity: inView ? 1 : 0.8,
                }}
              >
                <img 
                  className="w-full"
                  src={bannerImage}
                  alt={bannerImageAlt}
                />
                {/* Mask */}
                <div className="absolute top-0 left-0 w-full h-full bg-black opacity-20"></div>
              </div>
            </div>
          </div>
        )}
      </ScrollSnapBox>

        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-xl sm:text-3xl md:text-4xl lg:text-6xl font-bold text-white">
            {bannerTitle}
          </div>
        </div>
      </div>

      <div className='bg-gray-100'>
        <ScrollSnapBox>
        {({ inView }) => (
          <div className="relative overflow-hidden py-20">
            <div 
              className="transition-all duration-1000 ease-out text-center"
              style={{
                transform: `translateY(${inView ? '0' : '80px'})`,
                opacity: inView ? 1 : 0
              }}
            >
              <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-gray-800 mb-4 px-8 sm:px-10 md:px-12 lg:px-18">
                {welcomeTitle}
              </h2>
              <div 
                className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-600 mx-6 md:mx-12 px-4"
                style={{
                  transitionDelay: '200ms'
                }}
              >
                {welcomeDescription}
              </div>
            </div>
          </div>
        )}
      </ScrollSnapBox>
    </div>
    </>
  );
};

export default CommonBanner; 